import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export function MBCardQuantityHeader() {
  const colors = useContext(ColorThemeContext);
  return (
    <View row paddingHorizontal={2} paddingBottom={1}>
      <View style={{ width: grid(5) }}>
        <Text size="overline" align="center" color={colors.input.label}>
          {i18n('card.blocks.cardsInput.quantity.header.quantity')?.toUpperCase() ?? ''}
        </Text>
      </View>
      <View paddingLeft={2}>
        <Text size="overline" color={colors.input.label}>
          {i18n('card.blocks.cardsInput.quantity.header.name')?.toUpperCase() ?? ''}
        </Text>
      </View>
    </View>
  );
}
